export enum StorageTypes {
  USER = "USER",
  LAST_WIZARD_SETTINGS = "AR_WIZARD_NAV_STATE",
}
